var map = {
	"./index.html": 54
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 186;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/metallist/templates ^\.\/.*\.html$
 ** module id = 186
 ** module chunks = 1
 **/